const wordList8_3 = [
  { pl: 'zaczynać się', de: 'anfangen' },
  { pl: 'wkładać (ubranie)', de: 'anziehen' },
  { pl: 'wstawać', de: 'aufstehen' },
  { pl: 'budzić się', de: 'aufwachen' },
  { pl: 'brać prysznic', de: 'duschen' },
  { pl: 'robić zakupy', de: 'einkaufen' },
  { pl: 'jeść', de: 'essen' },
  { pl: 'oglądać telewizję', de: 'fernsehen' },
  { pl: 'jeść śniadanie', de: 'frühstücken' },
  { pl: 'pomagać', de: 'helfen' },
  { pl: 'iść do łazienki', de: 'ins Bad gehen' },
  { pl: 'spać', de: 'schlafen' },
  { pl: 'iść spać', de: 'schlafen gehen' },
  { pl: 'malować się', de: 'sich schminken' },
  { pl: 'myć zęby', de: 'Zähne putzen' },
  { pl: 'wracać', de: 'zurückkommen' },
  { pl: 'włączać', de: 'anmachen' },
  { pl: 'telefonować', de: 'anrufen' },
  { pl: 'puszczać (o płytach, muzyce)', de: 'auflegen' },
  { pl: 'wychodzić (z domu/do miasta w celach rozrywkowych)', de: 'ausgehen' },
  { pl: 'wyłączać', de: 'ausmachen' },
  { pl: 'mecz koszykówki', de: 'das Basketballspiel' },
  { pl: 'grać', de: 'laufen' },
  { pl: 'iść z kimś', de: 'mitgehen' },
  { pl: 'tańczyć', de: 'tanzen' },
  { pl: 'grypa', de: 'die Grippe' },
  { pl: 'kaszel', de: 'der Husten' },
  { pl: 'chory', de: 'krank' },
  { pl: 'katar', de: 'der Schnupfen' },
  { pl: 'móc, mieć pozwolenie', de: 'dürfen' },
  { pl: 'chcieć', de: 'wollen' },
  { pl: 'iść', de: 'gehen' },
  { pl: 'spotykać się', de: 'sich treffen' },
  { pl: 'umawiać się', de: 'sich verabreden' },
  { pl: 'kawiarnia', de: 'das Cafe' },
  { pl: 'dyskoteka', de: 'die Disco' },
  { pl: 'centrum handlowe', de: 'das Einkaufszentrum' },
  { pl: 'lodziarnia', de: 'die Eisdiele' },
  { pl: 'kino', de: 'das Kino' },
  { pl: 'park', de: 'der Park' },
  { pl: 'pizzeria', de: 'die Pizzeria' },
  { pl: 'restauracja', de: 'das Restaurant' },
  { pl: 'stadion', de: 'das Stadion' },
  { pl: 'ranek', de: 'der Morgen' },
  { pl: 'przedpołudnie', de: 'der Vormittag' },
  { pl: 'południe', de: 'der Mittag' },
  { pl: 'popołudnie', de: 'der Nachmittag' },
  { pl: 'wieczór', de: 'der Abend' },
  { pl: 'noc', de: 'die Nacht' },
  { pl: 'weekend', de: 'das Wochenende' },
  { pl: 'wpół do', de: 'halb' },
  { pl: 'po', de: 'nach' },
  { pl: 'przed, za', de: 'vor' },
  { pl: 'kwadrans (= piętnaście minut)', de: 'das Viertel' },
  { pl: 'odczepiać się (pot.)', de: 'abhauen' },
  { pl: 'To głupie.', de: 'Das ist blöd.' },
  { pl: 'Rozpęta się terror (awantura)!', de: 'Der Terror geht los!' },
  { pl: 'O kurczę! (pot.)', de: 'Mist!' },
  { pl: 'Wynoś się! (pot.)', de: 'Raus!' },
  { pl: 'Czego chcesz?', de: 'Was willst du?' },
];

export default wordList8_3;
